import React from "react";
import SideListView from "../Util/SideListView/SideListView";
import NavItem from "../Util/SideListView/NavItem";
import { PiBagFill } from "react-icons/pi";
import { IoDownload } from "react-icons/io5";
import { MdAccessibilityNew, MdMiscellaneousServices } from "react-icons/md";

// The investor navigation. Each link: see NavItem (RCMC-04/-09, ticket 11)
const UserSideListView = () => {
  return (
    <SideListView>
      <NavItem to="/user/portfolio" icon={PiBagFill} label="Portfolio" />
      <NavItem to="/user/service-request" icon={MdMiscellaneousServices} label="Service Requests" />
      <NavItem to="/user/download-forms" icon={IoDownload} label="Forms & FAQs" />
      {/* RCMC-15 (ticket 12): the public help page, on every signed-in investor page */}
      <NavItem to="/accessibility-help" icon={MdAccessibilityNew} label="Accessibility help" />
      {/* <li>
        <NavLink className={({isActive}) => isActive ? "active":""} to="/user/faq">
          <MdMessage />
          <strong>FAQs</strong>
        </NavLink>
      </li> */}
    </SideListView>
  );
};

export default UserSideListView;
